const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

function randomChar() {
  const bytes = new Uint8Array(1);
  crypto.getRandomValues(bytes);
  return ALPHABET[bytes[0] % ALPHABET.length];
}

export function generateSafeAccessCode() {
  const chars = Array.from({ length: 12 }, randomChar);
  return `${chars.slice(0, 4).join('')}-${chars.slice(4, 8).join('')}-${chars.slice(8).join('')}`;
}
